export const HISTOGRAM_BUCKETS = [
	{ key: 'gt5_early', label: '>5 early', side: 'early' },
	{ key: 'd5_early', label: '5 early', side: 'early' },
	{ key: 'd4_early', label: '4 early', side: 'early' },
	{ key: 'd3_early', label: '3 early', side: 'early' },
	{ key: 'd2_early', label: '2 early', side: 'early' },
	{ key: 'd1_early', label: '1 early', side: 'early' },
	{ key: 'on_time', label: 'On time', side: 'on_time' },
	{ key: 'd1_late', label: '1 late', side: 'late' },
	{ key: 'd2_late', label: '2 late', side: 'late' },
	{ key: 'd3_late', label: '3 late', side: 'late' },
	{ key: 'd4_late', label: '4 late', side: 'late' },
	{ key: 'gte5_late', label: '>=5 late', side: 'late' },
] as const;

export type HistogramBucketKey = (typeof HISTOGRAM_BUCKETS)[number]['key'];

const ON_OR_BEFORE = new Set<HistogramBucketKey>([
	'gt5_early',
	'd5_early',
	'd4_early',
	'd3_early',
	'd2_early',
	'd1_early',
	'on_time',
]);

/**
 * On-time bucket for a signed day delta (delivered date minus required ship
 * date). Negative is early. Missing ship or delivery date has no bucket.
 */
export function histogramBucket(
	deltaDays: number | null | undefined
): HistogramBucketKey | null {
	if (deltaDays === null || deltaDays === undefined || Number.isNaN(deltaDays)) {
		return null;
	}
	if (deltaDays <= -6) return 'gt5_early';
	if (deltaDays === -5) return 'd5_early';
	if (deltaDays === -4) return 'd4_early';
	if (deltaDays === -3) return 'd3_early';
	if (deltaDays === -2) return 'd2_early';
	if (deltaDays === -1) return 'd1_early';
	if (deltaDays === 0) return 'on_time';
	if (deltaDays === 1) return 'd1_late';
	if (deltaDays === 2) return 'd2_late';
	if (deltaDays === 3) return 'd3_late';
	if (deltaDays === 4) return 'd4_late';
	if (deltaDays >= 5) return 'gte5_late';
	return null;
}

/** Share of histogram lines delivered on or before the ship date. */
export function onTimeShare(
	bars: Array<{ key: string; count: number }>,
	histogramN: number
): { n: number; pct: number | null } {
	const n = bars
		.filter((bar) => ON_OR_BEFORE.has(bar.key as HistogramBucketKey))
		.reduce((sum, bar) => sum + bar.count, 0);
	if (histogramN === 0) return { n: 0, pct: null };
	return { n, pct: Math.round((n / histogramN) * 100) };
}
